<template>
  <modal class="modalCG" @before-open="iphoneModalsSet" @before-close="closingModal" :name="modalName" height="auto" :adaptive="true" :scrollable="true">
    <div class="modal-box">
      <div class="modal-header">
        <h2>Neue Adresse</h2>
        <span class="close" @click.prevent="toggleModal">
            <icon name="close" scale="2"></icon>
          </span>
      </div>
      <form>
      <h4 class="subheader">Persönliche Daten</h4>
      <div class="modal-body">
        <div class="form-field sized">
          <label for="address_firstname">Vorname</label>
          <input v-model="info.first_name" type="text" id="address_firstname" name="first_name" data-vv-as="Vorname" v-validate="'required'" :class="{'error': errors.has('first_name') }" placeholder="Vorname">
          <span v-show="errors.has('first_name')" class="errorMsg">{{ errors.first('first_name') }}</span>
        </div>
        <div class="form-field sized">
          <label for="address_lastname">Nachname</label>
          <input v-model="info.last_name" type="text" id="address_lastname" name="last_name" data-vv-as="Nachname" v-validate="'required'" :class="{'error': errors.has('last_name') }" placeholder="Nachname">
          <span v-show="errors.has('last_name')" class="errorMsg">{{ errors.first('last_name') }}</span>
        </div>
        <div class="form-field sized">
          <label for="address_company">Firma (optional)</label>
          <input v-model="info.company" type="text" name="company" id="address_company" placeholder="Firma">
        </div>
      </div>
      <h4 class="subheader">Anschrift</h4>
      <div class="modal-body">
        <div class="form-field sized">
          <label for="address_street">Straße</label>
          <input v-model="info.street" type="text" id="address_street" name="street" data-vv-as="Straße" v-validate="'required'" :class="{'error': errors.has('street') }" placeholder="Straße">
          <span v-show="errors.has('street')" class="errorMsg">{{ errors.first('street') }}</span>
        </div>
        <div class="form-field sized">
          <label for="address_number">Hausnummer</label>
          <input v-model="info.number" type="text" id="address_number" name="number" data-vv-as="Hausnummer" v-validate="'required'" :class="{'error': errors.has('number') }" placeholder="Hausnummer">
          <span v-show="errors.has('number')" class="errorMsg">{{ errors.first('number') }}</span>
        </div>
        <div class="form-field sized">
          <label for="address_zip">PLZ</label>
          <input v-model="info.zip" type="text" id="address_zip" name="zip" data-vv-as="PLZ" v-validate="'required'" :class="{'error': errors.has('zip') }" placeholder="PLZ">
          <span v-show="errors.has('zip')" class="errorMsg">{{ errors.first('zip') }}</span>
        </div>
        <div class="form-field sized">
          <label for="address_city">Stadt</label>
          <input v-model="info.city" type="text" id="address_city" name="city" data-vv-as="Stadt" v-validate="'required'" :class="{'error': errors.has('city') }" placeholder="Stadt">
          <span v-show="errors.has('city')" class="errorMsg">{{ errors.first('city') }}</span>
        </div>
        <div class="form-field sized">
          <label for="address_city">Region/Bundesland</label>
          <input v-model="info.region" type="text" id="address_region" name="region" data-vv-as="Bundesland" v-validate="'required'" :class="{'error': errors.has('region') }" placeholder="Region/Bundesland">
          <span v-show="errors.has('region')" class="errorMsg">{{ errors.first('region') }}</span>
        </div>
        <div class="form-field sized">
          <label >Land:</label>
          <input disabled="disabled" :value="landInfo.name" >
        </div>
      </div>
      <h4 class="subheader">Kontaktmöglichkeit</h4>
      <div class="modal-body">
        <div class="form-field sized">
          <label for="address_phone">Telefonnummer (optional)</label>
          <input type="text" name="tel" v-model="info.tel" id="address_phone">
        </div>
      </div>
      </form>
      <div class="modal-action">
        <button class="btn green" @click.prevent="addAddress">Neue Adresse speichern</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { EventBus } from '@/assets/js/event-bus.js'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'AddressModal',
    mounted () {
      EventBus.$on('toggleAddressModal', (address, name) => {
        if (this.modalName === name) {
          this.address = address
          this.toggleModal()
        }
      })
      EventBus.$on('escKey', () => {
        this.show = false
        this.$modal.hide(this.modalName)
      })
    },
    beforeDestroy () {
      EventBus.$off('toggleAddressModal')
      EventBus.$off('escKey')
    },
    props: {
      modalName: {
        type: String,
        default: 'address'
      }
    },
    mixins: [helpers, formatting],
    data () {
      return {
        show: false,
        address: null,
        saveToast: null,
        info: {
          'first_name': '',
          'last_name': '',
          'company': '',
          'tel': '',
          'street': '',
          'number': '',
          'city': '',
          'zip': '',
          'region': ''
        }
      }
    },
    methods: {
      ...mapActions([
        'saveAddress',
        'updateAddress'
      ]),
      closingModal () {
        this.show = false
        this.iphoneModalsUnset()
      },
      toggleModal () {
        var vm = this
        let i
        let keys = Object.keys(vm.info)
        if (vm.address) {
          for (i in keys) {
            if (vm.address.hasOwnProperty(keys[i])) {
              vm.info[keys[i]] = vm.address[keys[i]]
            }
          }
        } else {
          for (i in keys) {
            vm.info[keys[i]] = ''
          }
          vm.info['first_name'] = vm.account.first_name
          vm.info['last_name'] = vm.account.last_name
        }
        vm.errors.clear()
        vm.show = !vm.show
        this.show ? this.$modal.show(vm.modalName) : this.$modal.hide(vm.modalName)
      },
      emitAddress (address) {
        this.$emit('saved', address)
      },
      addAddress () {
        var vm = this
        vm.$validator.validateAll().then((result) => {
          if (result) {
            let cb, errorCb
            if (!vm.saveToast) {
              vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                icon: 'info'
              })
              if (!vm.address) {
                cb = (addressResponse) => {
                  vm.saveToast.goAway(100)
                  vm.saveToast = null
                  vm.emitAddress(addressResponse)
                  EventBus.$emit('toggleAddressModal', null, vm.modalName)
                  vm.$toasted.success('Deine Adresse wurde gespeichert.', {
                    theme: 'primary',
                    position: 'top-right',
                    duration: 10000,
                    action: {
                      text: 'X',
                      class: 'toastBtn',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                    icon: 'check'
                  })
                }
                errorCb = () => {
                  vm.saveToast.goAway(100)
                  vm.saveToast = null
                  EventBus.$emit('toggleAddressModal', null, vm.modalName)
                  vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
                    theme: 'primary',
                    position: 'top-right',
                    duration: 10000,
                    action: {
                      text: 'X',
                      class: 'toastBtn',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                    icon: 'close'
                  })
                }
                vm.saveAddress({user: vm.account.uid, data: vm.info, cb, errorCb})
              } else {
                cb = (addressResponse) => {
                  vm.saveToast.goAway(100)
                  vm.saveToast = null
                  vm.emitAddress(addressResponse)
                  EventBus.$emit('toggleAddressModal', null, vm.modalName)
                  vm.$toasted.success('Deine Adresse wurde aktualisiert.', {
                    theme: 'primary',
                    position: 'top-right',
                    duration: 10000,
                    action: {
                      text: 'X',
                      class: 'toastBtn',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                    icon: 'check'
                  })
                }
                errorCb = () => {
                  vm.saveToast.goAway(100)
                  vm.saveToast = null
                  EventBus.$emit('toggleAddressModal', null, vm.modalName)
                  vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
                    theme: 'primary',
                    position: 'top-right',
                    duration: 10000,
                    action: {
                      text: 'X',
                      class: 'toastBtn',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                    icon: 'close'
                  })
                }
                vm.updateAddress({user: vm.account.uid, address: vm.address.uid, data: vm.info, cb, errorCb})
              }
            }
          }
        })
      }
    },
    computed: {
      ...mapGetters({
        account: 'auth_get_account',
        landInfo: 'options_get_land'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/Address.vue